import React, { useContext, useRef, useState } from 'react'
import { Stack } from '@mui/material'
import API from '../../../services/API'
import { useNavigate } from 'react-router-dom'
import { GlobalContext } from '../../../App'
import UnsavedChanges from '../../../components/UnsavedChanges/UnsavedChanges'
import MakeReadyCheckPanel from './MakeReadyCheckPanel'

const Requirements = () => {
  const panelRef = useRef()
  const [dirty, setDirty] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()
  const { setToast } = useContext(GlobalContext)

  const handleSubmit = () => {
    if (submitting || !panelRef.current) return

    if (!panelRef.current.isValid()) {
      setToast({
        message:
          'Confirm every expected asset (and pick a replacement for anything marked "Replaced") before completing this check',
        severity: 'error',
      })
      return
    }

    const payload = panelRef.current.getPayload()

    setSubmitting(true)
    API.post('/updatemakereadyinventory', payload)
      .then((res) => {
        if (res.status === 200) {
          panelRef.current.clearDirty()
          navigate('/make-ready-overview')
          setToast({ message: 'Make Ready Check Completed' })
        } else {
          setToast({
            message: 'Failed to submit Make Ready',
            severity: 'error',
          })
        }
      })
      .catch((e) => {
        console.error(e)
        setToast({ message: 'Failed to submit Make Ready', severity: 'error' })
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <Stack gap={2}>
      <MakeReadyCheckPanel ref={panelRef} onDirtyChange={setDirty} />
      <UnsavedChanges
        changesPresent={dirty}
        handleSave={handleSubmit}
        title="MAKE READY CHECK IN PROGRESS"
        saveButtonText={submitting ? 'Completing...' : 'Complete Check'}
      />
    </Stack>
  )
}

export default Requirements
